<template>
  <div>
    <div class="ccrs-results__fst-design__headline h5">
      {{ headline }}
    </div>
    <table v-if="!isMobile">
      <thead>
        <tr>
          <th
            v-for="(header, i) in headers"
            :key="i"
          >
            {{ header }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, i) of data"
          :key="i"
        >
          <td
            v-for="(td, j) of slotsProceced"
            :key="i + '-' + j"
          >
            <slot
              v-if="td.hasSlot"
              :name="td.slotName"
              :item="item"
            />
            <span v-else>{{ item[td.key] }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="isMobile">
      <div
        v-for="(item, i) of data"
        :key="i"
        class="ccrs-results__fst-design__mobileView__row"
      >
        <div
          v-for="(td, j) of slotsProceced"
          :key="i + '-' + j"
          class="ccrs-results__fst-design__mobileView__row__entry"
        >
          <div class="ccrs-results__fst-design__mobileView__row__entry__header">
            {{ headers[td.key] }}
          </div>
          <div>
            <slot
              v-if="td.hasSlot"
              :name="td.slotName"
              :item="item"
            />
            <span v-else>{{ item[td.key] }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {MOBILE_BREAKPOINT} from '~/assets/js/constants'
export default {
  name: 'CcrsTable',
  props: {
    headers: {
      type: Object,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    headline: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      slotsProceced: [],
      isMobile: false
    }
  },
  beforeUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, {passive: true})
    }
  },
  mounted() {
    this.onResize()
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.onResize, {passive: true})
    }
  },
  watch: {
    headers: {
      immediate: true,
      handler() {
        this.setupSlots()
      }
    }
  },
  methods: {
    setupSlots() {
      for (const key in this.headers) {
        if (Object.prototype.hasOwnProperty.call(this.headers, key)) {
          const slotName = 'item-' + key
          this.slotsProceced.push({
            key: key,
            hasSlot: true,
            slotName: slotName
          })
        }
      }
    },
    onResize() {
      this.isMobile = window.innerWidth < MOBILE_BREAKPOINT
    }
  }
}
</script>
